import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../util/apiUtils";
import { method } from "lodash";

const initialState = {
  data: { loading: true },
};

// export const getProfile = createAsyncThunk(
//   "profile/getProfile",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await apiRequest("get", "profile");
//       return res;
//     } catch (error) {
//       rejectWithValue(error);
//     }
//   }
// );

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.data = action?.payload;
    },
  },
});

export const { setProfile } = profileSlice?.actions;
export default profileSlice?.reducer;
